import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "../button";
import IconClose from "../icons/close";
import Localization from "../../localization";

import { changeNewsletter } from "../../redux/actions/options";
import { subscribeNewsletter } from "../../redux/actions/newsletter";
import { getMe } from "../../redux/selectors/me";

class Newsletter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            subscribed: false,
        };

        this._close = this._close.bind(this);
        this._onPress = this._onPress.bind(this);
        this._emailChanged = this._emailChanged.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!this.props.isSubscribing && prevProps.isSubscribing) {
            if (!this.state.error) {
                this.setState(
                    {
                        subscribed: true,
                    },
                    () => {
                        setTimeout(() => {
                            this._close();
                        }, 1000);
                    }
                );
            }
        }
    }

    _emailChanged(event) {
        this.setState({
            email: event.target.value,
        });
    }

    _close() {
        this.props.changeNewsletter(false);
    }

    _onPress() {
        if (this.state.email.length > 0) {
            this.props.subscribeNewsletter(this.state.email);
        }
    }

    render() {
        const {
            isNewsletterVisible,
            locale,
            isSubscribing,
            backgroundColor,
            textColor,
            buttonBackgroundColor,
            buttonTextColor,
            borderColor,
            placeholderColor,
            user,
        } = this.props;
        const { email, subscribed } = this.state;

        let className =
            "fixed bottom-0 left-0 right-0 transition duration-700 ease-in-out transform z-20";

        if (!isNewsletterVisible) {
            className += " " + "translate-y-full opacity-0";
        }

        if (user && user.newsletter) return null;

        return (
            <div className={className}>
                <div className="h-20 xl:hidden" />
                <div
                    className={
                        "xl:flex p-16 xl:px-50 xl:py-30 " + backgroundColor
                    }
                >
                    <div className="hidden xl:block pb-10 xl:pb-0 w-50 xl:w-70 ml-auto xl:ml-0">
                        <Button
                            icon={
                                <IconClose
                                    className={
                                        "w-20 h-20 xl:w-25 xl:h-25 z-10 transition hover-hover:group-hover:" +
                                        buttonTextColor +
                                        " " +
                                        textColor
                                    }
                                />
                            }
                            backgroundColorOver={buttonBackgroundColor}
                            borderColor={borderColor}
                            onClick={this._close}
                            style="w-50 xl:w-70"
                            height="h-32 xl:h-46"
                        />
                    </div>
                    <div className="absolute top-0 left-0 right-0 xl:hidden w-full flex justify-center">
                        <Button
                            icon={
                                <IconClose
                                    className={
                                        "w-22 h-22 z-10 transition hover-hover:group-hover:" +
                                        buttonTextColor +
                                        " " +
                                        textColor
                                    }
                                />
                            }
                            backgroundColor={backgroundColor}
                            backgroundColorOver={buttonBackgroundColor}
                            borderColor={borderColor}
                            onClick={this._close}
                            style="w-60"
                            height="h-40"
                        />
                    </div>
                    <p
                        className={
                            "xl:hidden font-bold mt-20 mb-12 text-center text-15 " +
                            textColor
                        }
                    >
                        {subscribed
                            ? Localization[locale].newsletter.success
                            : Localization[locale].newsletter.text}
                    </p>
                    <div className="flex-1 mb-20 xl:mb-0">
                        <div className="xl:flex xl:mb-12">
                            <div className="xl:w-6/12 flex justify-end">
                                <input
                                    placeholder={
                                        Localization[locale].newsletter
                                            .placeholder
                                    }
                                    type="email"
                                    name="email"
                                    disabled={isSubscribing || subscribed}
                                    value={email}
                                    onChange={this._emailChanged}
                                    className={
                                        "px-20 text-center xl:text-left bg-transparent w-full xl:w-auto rounded-full h-46 border " +
                                        borderColor +
                                        " " +
                                        placeholderColor +
                                        " font-bold " +
                                        textColor +
                                        " xl:mr-10 text-20 xl:text-23 focus:ring-0 mb-10 xl:mb-0 focus:" +
                                        borderColor
                                    }
                                />
                            </div>
                            <div className="xl:w-4/12">
                                <Button
                                    text={Localization[
                                        locale
                                    ].newsletter.button.toUpperCase()}
                                    disabled={
                                        email.length === 0 ||
                                        isSubscribing ||
                                        subscribed
                                    }
                                    backgroundColor={buttonBackgroundColor}
                                    backgroundColorOver={buttonBackgroundColor}
                                    borderColor={borderColor}
                                    textStyle={
                                        "font-judge text-20 xl:text-22 z-10 transition " +
                                        buttonTextColor +
                                        " disabled:cursor-not-allowed"
                                    }
                                    onClick={this._onPress}
                                    style={"w-full xl:w-310"}
                                    height="h-46"
                                />
                            </div>
                        </div>
                        <div className="hidden xl:flex">
                            <div className="xl:w-6/12" />
                            <div className="xl:w-6/12">
                                <p
                                    className={
                                        "pl-6 font-bold text-center xl:text-left text-15 xl:text-17 " +
                                        textColor
                                    }
                                >
                                    {subscribed
                                        ? Localization[locale].newsletter
                                              .success
                                        : Localization[locale].newsletter.text}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Newsletter.defaultProps = {
    backgroundColor: "bg-aqua-blue",
    textColor: "text-blue",
    buttonBackgroundColor: "bg-blue",
    buttonTextColor: "text-aqua-blue",
    borderColor: "border-blue",
    placeholderColor: "placeholder-blue",
};

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    isNewsletterVisible: state.app.isNewsletterVisible,
    isSubscribing: state.newsletter.isSubscribing,
    error: state.newsletter.error,
    user: getMe(state),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeNewsletter,
            subscribeNewsletter,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Newsletter);
